import makeStyles from '@mui/styles/makeStyles';

const useDarkTheme = makeStyles(() => ({
  disabledTextLight: {
    color: 'var(--text-disabled-light)',
    '&.Mui-disabled': {
      color: 'var(--text-disabled-light)',
    },
  },
  divider: {
    borderColor: 'var(--divider-color-light-dark)',
    opacity: 0.2,
  },
  linkLight: {
    color: 'var(--text-primary-light)',
    textDecoration: 'underline',
    '&:hover': {
      color: 'var(--text-primary-light)',
      textDecoration: 'none',
    },
  },
  primaryTextLight: {
    color: 'var(--text-primary-light)',
  },
  secondaryTextLight: {
    color: 'var(--text-secondary-light)',
  },
}));

export default useDarkTheme;
